// extracted by mini-css-extract-plugin
module.exports = {"root":"EmployeeOverview_root__IREcV","button":"EmployeeOverview_button__2hqzd","selectableSelect":"EmployeeOverview_selectableSelect__3Lguv"};